import { render, staticRenderFns } from "./Alpha.vue?vue&type=template&id=857eb23e"
import script from "./Alpha.vue?vue&type=script&lang=js"
export * from "./Alpha.vue?vue&type=script&lang=js"
import style0 from "./Alpha.vue?vue&type=style&index=0&id=857eb23e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports